import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-apply',
  templateUrl: './icon-apply.component.html',
  styleUrls: ['./icon-apply.component.scss']
})
export class IconApplyComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
